/** @license MUI v5.0.0-alpha.87
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BadgeUnstyled: true,
  ButtonUnstyled: true,
  ClickAwayListener: true,
  unstable_composeClasses: true,
  generateUtilityClass: true,
  generateUtilityClasses: true,
  FormControlUnstyled: true,
  InputUnstyled: true,
  MenuUnstyled: true,
  MenuItemUnstyled: true,
  ModalUnstyled: true,
  MultiSelectUnstyled: true,
  NoSsr: true,
  OptionGroupUnstyled: true,
  OptionUnstyled: true,
  PopperUnstyled: true,
  Portal: true,
  SelectUnstyled: true,
  SliderUnstyled: true,
  SwitchUnstyled: true,
  TabPanelUnstyled: true,
  TabsListUnstyled: true,
  TabsUnstyled: true,
  TabUnstyled: true,
  TextareaAutosize: true,
  TrapFocus: true
};
Object.defineProperty(exports, "BadgeUnstyled", {
  enumerable: true,
  get: function () {
    return _BadgeUnstyled.default;
  }
});
Object.defineProperty(exports, "ButtonUnstyled", {
  enumerable: true,
  get: function () {
    return _ButtonUnstyled.default;
  }
});
Object.defineProperty(exports, "ClickAwayListener", {
  enumerable: true,
  get: function () {
    return _ClickAwayListener.default;
  }
});
Object.defineProperty(exports, "FormControlUnstyled", {
  enumerable: true,
  get: function () {
    return _FormControlUnstyled.default;
  }
});
Object.defineProperty(exports, "InputUnstyled", {
  enumerable: true,
  get: function () {
    return _InputUnstyled.default;
  }
});
Object.defineProperty(exports, "MenuItemUnstyled", {
  enumerable: true,
  get: function () {
    return _MenuItemUnstyled.default;
  }
});
Object.defineProperty(exports, "MenuUnstyled", {
  enumerable: true,
  get: function () {
    return _MenuUnstyled.default;
  }
});
Object.defineProperty(exports, "ModalUnstyled", {
  enumerable: true,
  get: function () {
    return _ModalUnstyled.default;
  }
});
Object.defineProperty(exports, "MultiSelectUnstyled", {
  enumerable: true,
  get: function () {
    return _MultiSelectUnstyled.default;
  }
});
Object.defineProperty(exports, "NoSsr", {
  enumerable: true,
  get: function () {
    return _NoSsr.default;
  }
});
Object.defineProperty(exports, "OptionGroupUnstyled", {
  enumerable: true,
  get: function () {
    return _OptionGroupUnstyled.default;
  }
});
Object.defineProperty(exports, "OptionUnstyled", {
  enumerable: true,
  get: function () {
    return _OptionUnstyled.default;
  }
});
Object.defineProperty(exports, "PopperUnstyled", {
  enumerable: true,
  get: function () {
    return _PopperUnstyled.default;
  }
});
Object.defineProperty(exports, "Portal", {
  enumerable: true,
  get: function () {
    return _Portal.default;
  }
});
Object.defineProperty(exports, "SelectUnstyled", {
  enumerable: true,
  get: function () {
    return _SelectUnstyled.default;
  }
});
Object.defineProperty(exports, "SliderUnstyled", {
  enumerable: true,
  get: function () {
    return _SliderUnstyled.default;
  }
});
Object.defineProperty(exports, "SwitchUnstyled", {
  enumerable: true,
  get: function () {
    return _SwitchUnstyled.default;
  }
});
Object.defineProperty(exports, "TabPanelUnstyled", {
  enumerable: true,
  get: function () {
    return _TabPanelUnstyled.default;
  }
});
Object.defineProperty(exports, "TabUnstyled", {
  enumerable: true,
  get: function () {
    return _TabUnstyled.default;
  }
});
Object.defineProperty(exports, "TabsListUnstyled", {
  enumerable: true,
  get: function () {
    return _TabsListUnstyled.default;
  }
});
Object.defineProperty(exports, "TabsUnstyled", {
  enumerable: true,
  get: function () {
    return _TabsUnstyled.default;
  }
});
Object.defineProperty(exports, "TextareaAutosize", {
  enumerable: true,
  get: function () {
    return _TextareaAutosize.default;
  }
});
Object.defineProperty(exports, "TrapFocus", {
  enumerable: true,
  get: function () {
    return _TrapFocus.default;
  }
});
Object.defineProperty(exports, "generateUtilityClass", {
  enumerable: true,
  get: function () {
    return _generateUtilityClass.default;
  }
});
Object.defineProperty(exports, "generateUtilityClasses", {
  enumerable: true,
  get: function () {
    return _generateUtilityClasses.default;
  }
});
Object.defineProperty(exports, "unstable_composeClasses", {
  enumerable: true,
  get: function () {
    return _composeClasses.default;
  }
});

var _utils = require("./utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _utils[key];
    }
  });
});

var _AutocompleteUnstyled = require("./AutocompleteUnstyled");

Object.keys(_AutocompleteUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AutocompleteUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AutocompleteUnstyled[key];
    }
  });
});

var _BadgeUnstyled = _interopRequireWildcard(require("./BadgeUnstyled"));

Object.keys(_BadgeUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BadgeUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BadgeUnstyled[key];
    }
  });
});

var _ButtonUnstyled = _interopRequireWildcard(require("./ButtonUnstyled"));

Object.keys(_ButtonUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ButtonUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ButtonUnstyled[key];
    }
  });
});

var _ClickAwayListener = _interopRequireDefault(require("./ClickAwayListener"));

var _composeClasses = _interopRequireDefault(require("./composeClasses"));

var _generateUtilityClass = _interopRequireWildcard(require("./generateUtilityClass"));

Object.keys(_generateUtilityClass).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _generateUtilityClass[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generateUtilityClass[key];
    }
  });
});

var _generateUtilityClasses = _interopRequireDefault(require("./generateUtilityClasses"));

var _FormControlUnstyled = _interopRequireWildcard(require("./FormControlUnstyled"));

Object.keys(_FormControlUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormControlUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormControlUnstyled[key];
    }
  });
});

var _InputUnstyled = _interopRequireWildcard(require("./InputUnstyled"));

Object.keys(_InputUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InputUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InputUnstyled[key];
    }
  });
});

var _ListboxUnstyled = require("./ListboxUnstyled");

Object.keys(_ListboxUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListboxUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListboxUnstyled[key];
    }
  });
});

var _MenuUnstyled = _interopRequireWildcard(require("./MenuUnstyled"));

Object.keys(_MenuUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MenuUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MenuUnstyled[key];
    }
  });
});

var _MenuItemUnstyled = _interopRequireWildcard(require("./MenuItemUnstyled"));

Object.keys(_MenuItemUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MenuItemUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MenuItemUnstyled[key];
    }
  });
});

var _ModalUnstyled = _interopRequireWildcard(require("./ModalUnstyled"));

Object.keys(_ModalUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ModalUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalUnstyled[key];
    }
  });
});

var _MultiSelectUnstyled = _interopRequireWildcard(require("./MultiSelectUnstyled"));

Object.keys(_MultiSelectUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MultiSelectUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MultiSelectUnstyled[key];
    }
  });
});

var _NoSsr = _interopRequireDefault(require("./NoSsr"));

var _OptionGroupUnstyled = _interopRequireWildcard(require("./OptionGroupUnstyled"));

Object.keys(_OptionGroupUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _OptionGroupUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OptionGroupUnstyled[key];
    }
  });
});

var _OptionUnstyled = _interopRequireWildcard(require("./OptionUnstyled"));

Object.keys(_OptionUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _OptionUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OptionUnstyled[key];
    }
  });
});

var _PopperUnstyled = _interopRequireDefault(require("./PopperUnstyled"));

var _Portal = _interopRequireDefault(require("./Portal"));

var _SelectUnstyled = _interopRequireWildcard(require("./SelectUnstyled"));

Object.keys(_SelectUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SelectUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SelectUnstyled[key];
    }
  });
});

var _SliderUnstyled = _interopRequireWildcard(require("./SliderUnstyled"));

Object.keys(_SliderUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SliderUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SliderUnstyled[key];
    }
  });
});

var _SwitchUnstyled = _interopRequireWildcard(require("./SwitchUnstyled"));

Object.keys(_SwitchUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SwitchUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SwitchUnstyled[key];
    }
  });
});

var _TabPanelUnstyled = _interopRequireWildcard(require("./TabPanelUnstyled"));

Object.keys(_TabPanelUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TabPanelUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TabPanelUnstyled[key];
    }
  });
});

var _TabsListUnstyled = _interopRequireWildcard(require("./TabsListUnstyled"));

Object.keys(_TabsListUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TabsListUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TabsListUnstyled[key];
    }
  });
});

var _TabsUnstyled = _interopRequireWildcard(require("./TabsUnstyled"));

Object.keys(_TabsUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TabsUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TabsUnstyled[key];
    }
  });
});

var _TabUnstyled = _interopRequireWildcard(require("./TabUnstyled"));

Object.keys(_TabUnstyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TabUnstyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TabUnstyled[key];
    }
  });
});

var _TextareaAutosize = _interopRequireDefault(require("./TextareaAutosize"));

var _TrapFocus = _interopRequireDefault(require("./TrapFocus"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }